<app-checkbox
  label="Include deleted users in the closer report"
  [defaultValue]="false"
  (Change)="includeDeleted = $event">
</app-checkbox>
